import styled, { css } from "styled-components";

export const DayText = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 30px;
    height: 30px;

    font-size: 14px;
    
    cursor: pointer;
    &:hover {
      font-weight: 600;
    }
    
    ${p => p.inSelectedPeriod && css`
      border-radius: 8px;
      background-color: #A5E5C4;
    `}
    
    color: ${p => p.selected ? '#FFFFFF' : '#444'};
    background-color: ${p => p.selected && (theme?.colour?.primary ?? '#1DBD6B')};
    font-weight: ${p => p.selected ? 600 : 400};
    border-radius: ${p => p.selected && '50%'};

    ${p => p.disabled && css`
      cursor: not-allowed;
      color: #AAA;
    `}
  `}
`;